module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-1-yellow.svg";